import isEmpty from 'lodash/isEmpty';
import forOwn from 'lodash/forOwn';
import extend from 'lodash/extend';
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class FileUploadService {
  constructor(private http: HttpClient,
              @Inject('AppConfig') private _config: any) {
  }

  public upload(file: File, url: string, params?: any): Promise<any> {
    const initParams = {
      reportProgress: true,
      withCredentials: true,
    };

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    if (params && !isEmpty(params)) {
      let httpParams = new HttpParams();
      forOwn(params, (val, key) => {
        httpParams = httpParams.set(key, val);
      });

      extend(initParams, { params: httpParams });
    }

    const req = new HttpRequest('POST', url, formData, initParams);

    return lastValueFrom(this.http.request(req));
  }

  public importReminders(reminders: File, groupId: number, reason: string) {
    const url = `${this._config.api.users.host}${this._config.api.users.import_reminders.replace(':reminderGroupId', groupId)}/`;
    return this.upload(reminders, url, { reason });
  }
}
